import CommonSeeMemory from '../commonfile/CommonSeeMemory'

const ShareMemory = () => {
  return (
       <CommonSeeMemory/>
  )
}

export default ShareMemory